import api, { fetchData } from './api';
import Paginacao from '../types/paginacao';
import Warehouse from '../types/warehouse';

export interface WarehouseApiResponse {
  data: Warehouse;
  messages: any; 
}

export const getWarehousesPaginated = async (
    paginacao: Paginacao
  ) => {
    try {
      const endpoint: string = '/Warehouse/all/paginado';
      const params: Record<string, any> = {
        pageNum: paginacao.pageNum + 1,
        quantityPerPage: paginacao.quantityPerPage,
        order: paginacao.order,
        sort: paginacao.sort,
      };
  
      const response = await fetchData<Warehouse>(endpoint, params);
  
      return response;
    } catch (error) {
      console.error('Erro ao buscar lista de suppliers:', error);
      throw error;
    }
};

export const getWarehouses = async () => {
  try {
    const endpoint: string = 'Warehouse/all';
    const response = await fetchData<Warehouse>(endpoint, {});
    return response;
  } catch (error) {
    console.error(`Erro ao buscar supplier`, error);
    throw error;
  }
};
  
  export const getWarehouseById = async (id: number) => {
    try {
      const response = await api.get(`/Warehouse/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar warehouse com ID ${id}`, error);
      throw error;
    }
  };

  export const deleteWarehouse = async (id: number) => {
    try {
      const response = await api.delete(`/Warehouse/delete/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao excluir warehouse com ID ${id}`, error);
      throw error;
    }
  };
  
  export const getWarehouse = async () => {
    try {
      const endpoint: string = 'Warehouse/all';
      const response = await fetchData<Warehouse>(endpoint, {});
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar warehouse`, error);
      throw error;
    }
  };
  
  export const createWarehouse = async (warehouse: Warehouse) => {
    try {
      const response = await api.post('Warehouse', warehouse);
      return response.data;
    } catch (error) {
      console.error('Erro ao cadastrar warehouse');
      throw error;
    }
  };
  
  export const updateWarehouse = async (id: number, warehouse: Warehouse) => {
    try {
      const response = await api.put(`/Warehouse/update/${id}`, warehouse);
      return response.data;
    } catch (error: any) {
      console.error('Error updating warehouse:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
      throw error;
    }
  };